import { sharedLogout as d } from "../../../auth-lib/utils/sessionCookies.js";
import { ERROR_CODE as k } from "../../constants/error.js";
import { CustomError as w } from "../../errors/customError.js";
import { getRefreshToken as f, getAccessToken as h } from "../../util/authenication/index.js";
import { sameTokenSession as p } from "../../util/authenication/token.js";
import { renewAccessToken as A, sessionExpiredError as E } from "./refreshToken.js";
const O = async (n, a) => {
  var i;
  if (!a) return n.status === 401;
  const t = await n.clone().json().catch(() => null);
  return t != null && t.data && Object.values(t.data).some((s) => s !== null) ? !1 : n.status === 401 || !!((i = t == null ? void 0 : t.errors) != null && i.some(
    (s) => {
      var u, c, o;
      return ((u = s.extensions) == null ? void 0 : u.subCode) === k.GRAPHQL.FORCE_LOGOUT || ((c = s.extensions) == null ? void 0 : c.code) === "UNAUTHENTICATED" || ((o = s.extensions) == null ? void 0 : o.code) === "UNAUTHORIZED";
    }
  ));
}, L = async (n, a, t) => {
  const { loginDomain: i, authRequired: s = !0, graphql: u = !1 } = t, c = d(), o = f(), l = h();
  let e = l || o || s ? await A(i) : null;
  if (!e && s) throw E();
  const R = () => {
    var r;
    if (d() !== c || f() !== o || (e ? h() !== e : h() !== l))
      throw new w("Your login session changed. Please try again.");
    if ((r = a.signal) != null && r.aborted)
      throw new DOMException("The request was aborted.", "AbortError");
  }, m = () => {
    R();
    const r = new Headers(a.headers);
    return e ? r.set("Authorization", `Bearer ${e}`) : r.delete("Authorization"), fetch(
      typeof Request < "u" && n instanceof Request ? n.clone() : n,
      {
        ...a,
        headers: r,
        ...e ? { cache: "no-store" } : {}
      }
    );
  }, g = await m(), T = h();
  if (d() !== c || f() !== o || !o && T !== (e || l) && !p(T, e || l))
    throw new w("Your login session changed. Please try again.");
  if (!await O(g, u) || !o)
    return g;
  if (f() !== o)
    throw new w("Your login session changed. Please try again.");
  if (e = await A(i, {
    force: !0,
    rejectedAccessToken: e
  }), !e) throw E();
  return m();
};
export {
  L as fetchWithAuth
};
//# sourceMappingURL=authFetch.js.map
